import { Injectable,Inject } from '@angular/core';
import {SESSION_STORAGE,StorageService} from 'angular-webstorage-service'

@Injectable({
  providedIn: 'root'
})
export class SessionsService {

  constructor(@Inject(SESSION_STORAGE) private storage:StorageService) { }

  /** setSession function used to set session */
  setSession(key:string,value:any)
  {
      /** console.log('key'+key);*/
      this.storage.set(key,value);
      /** if(this.storage.get("id")!=null)
      {
        this.storage.set('varified_users', value);
      } else {
        window.location.href="#/visitorview";
      }*/
  }

  /** getSession function used to get session */
  getSession(key:string)
  {
    return this.storage.get(key);
  }

  /** removeSession function used to remove session */
  removeSession(key:string)
  {
    return this.storage.remove(key);
  }
  
}
